// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const StarFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.828 17.229a.413.413 0 0 1-.181-.041L9 14.941l-4.647 2.245a.417.417 0 0 1-.596-.42l.599-5.367L.874 7.43a.416.416 0 0 1 .228-.682l5.02-1.056 2.51-4.7a.416.416 0 0 1 .735 0l2.51 4.7 5.021 1.056a.417.417 0 0 1 .228.682l-3.482 3.97.598 5.366a.417.417 0 0 1-.414.463Z"
			fill="#F8D22D"
		/>
	</svg>
);
export default StarFilled;
